import type { Feature, FeatureCollection, Polygon } from 'geojson'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapSingle } from '../normalize'

export type StratifyFarmParams = {
  stratasConfig: Record<string, unknown>
  perimeter: Feature<Polygon>
  signal?: AbortSignal
}

export default async function stratifyFarm({
  stratasConfig,
  perimeter,
  signal,
}: StratifyFarmParams): Promise<FeatureCollection> {
  const body = {
    ...stratasConfig,
    perimeter: { type: 'FeatureCollection', features: [perimeter] },
  }

  const response = await apiClient.post(endpoints.stratification.stratifyFarm, body, { signal })
  return unwrapSingle<{ vectorized_stratas: FeatureCollection }>(response).vectorized_stratas
}
